import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cart",
  "use": "icon-cart-usage",
  "viewBox": "0 0 21 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"cart-icon\" viewBox=\"0 0 21 18\" id=\"icon-cart\"><path fill-rule=\"evenodd\" d=\"M20 17H1V6h19v11zM14.713 5H6.287C8.9-.311 12.1-.311 14.713 5zm1.1 0c-1.559-3.354-3.298-5-5.313-5-2.015 0-3.754 1.646-5.313 5H0v13h21V5h-5.187z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol